import { ref } from "vue";
import { defineStore } from "pinia";
import { $http } from "@/plugins/api";
import { getApiClientUrl } from "@/config/runtimeConfig";
import type { Organisation } from "@/types/organisatio";

export interface DropDownRequest {
  globalOrganisationID: string | null | undefined;
  params: Record<string, string | number | boolean>;
}

const buildUrl = ({
  globalOrganisationID,
  params,
}: DropDownRequest): string => {
  const url = new URL(`${getApiClientUrl()}/v1/idp/orgs`);
  const reqParams = new URLSearchParams();

  if (globalOrganisationID) {
    reqParams.append("parent_uuid", globalOrganisationID);
  }

  for (const [key, value] of Object.entries(params)) {
    reqParams.append(key, value.toString());
  }

  url.search = reqParams.toString();

  return url.toString();
};

export const useDropDownStore = defineStore("dropDown", () => {
  const list = ref<Organisation[]>([]);
  const total = ref(0);

  const getDropDownList = async (request: DropDownRequest): Promise<void> => {
    const res = await $http.get(buildUrl(request));

    list.value = res.data.data;
    total.value = res.data.total ?? 0;
  };

  const appendDropDownList = async (
    request: DropDownRequest,
  ): Promise<void> => {
    const res = await $http.get(buildUrl(request));

    list.value = [...list.value, ...res.data.data];
    total.value = res.data.total ?? 0;
  };

  const resetState = (): void => {
    list.value = [];
    total.value = 0;
  };

  return {
    list,
    total,
    getDropDownList,
    appendDropDownList,
    resetState,
  };
});
